import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import PublicCoursesPage from "@/pages/PublicCoursesPage";
import CancellationPage from "@/pages/CancellationPage";
import ReactivationPage from "@/pages/ReactivationPage";
import CourseWidgetPage from "@/pages/CourseWidgetPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/kurse" element={<PublicCoursesPage />} />
        <Route path="/kurse/:courseId" element={<PublicCoursesPage />} />
        <Route path="/kurse/stornierung/:token" element={<CancellationPage />} />
        <Route path="/kurse/reaktivierung/:token" element={<ReactivationPage />} />
        <Route path="/kurse/widget" element={<CourseWidgetPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
